import OrderRecordMain from '@/components/OrderRecord'
const OrderRecord = () => {
    const element = (<OrderRecordMain />)
    return element
}
export default OrderRecord